import { createContext } from "react";

import type { AppConfigContextValue } from "./AppConfigContextValue";

export const AppConfigContext = createContext<AppConfigContextValue | null>(null);

AppConfigContext.displayName = "AppConfigContext";
